import React, { useState } from 'react';
import styles from './ToggleButtonBar.module.css'

const tabs = [
    'Home',
    'Device Health',
    'Latency',
    'ING Report',
    // 'EOL Report',
];

const ToggleButtonBar = ({activeTab, setActiveTab}) => {

    return (
        <div className={`${styles.bg_screen} mt-1`}>
            <div className={`mb-1 card`}>
                <div className="col-12">
                    <div className={`nav ${styles.tabs}`}>
                        {tabs.map((tab) => (
                            <div key={tab} className='mx-1'>
                                <button
                                    className={`${styles.nav_bar_buttons} ${activeTab === tab ? styles.tab_bar : ''}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ToggleButtonBar;
